module.exports = __webpack_public_path__ + "img/img_disease2.edf28f3d.jpg";